<div class="w-full">
  <ng-container *ngIf="options$ | async as options">
    <jml-lib-multiselect-cell
      [header]="field.header"
      (completeCellEdit)="emitComplete($event)"
      [fieldName]="field.field"
      [value]="selectedEntries"
      [editable]="editable"
      [options]="options"
      [tableReference]="tableReference"
      [showLabel]="field?.showLabel ?? true"
      [showIcon]="field?.showIcon ?? true"
      [showTooltip]="field?.showTooltip ?? true"
      [customEdit]="customEdit"
      (onCustomEdit)="emitOnCustomEdit()"
    >
    </jml-lib-multiselect-cell>
  </ng-container>
</div>
